import React, {Fragment} from 'react';
import {Input, Col, Row, Button} from 'reactstrap';
import {sources} from '../types/general-types';
import {FormattedMessage} from 'react-intl';

interface propiedades {
  fuentes: sources[];
  setFuentes: (fuentes: sources[]) => void;
}

const Fuentes = (props: propiedades) => {
  const {fuentes, setFuentes} = props;

  const handleFuentesChange = (
    index: number,
    e: React.ChangeEvent<HTMLInputElement>,
    key: string,
  ) => {
    const newState = [...fuentes];
    key === 'href'
      ? (newState[index].href = e.target.value)
      : (newState[index].description = e.target.value);
    setFuentes(newState);
  };

  const agregarNuevaFuente = () => {
    const sources = [...fuentes];
    sources.push({href: '', description: ''});
    setFuentes(sources);
  };

  return (
    <Fragment>
      <Row>
        <Col className="mb-2">
          <FormattedMessage id="sources" defaultMessage="sources" />:
        </Col>
      </Row>
      <Row>
        {fuentes?.map((source, index) => {
          return (
            <Fragment key={index}>
              <Col md={3}>
                <Input
                  type="text"
                  value={source.description}
                  onChange={(event) =>
                    handleFuentesChange(index, event, 'description')
                  }
                />
              </Col>
              <Col md={9}>
                <Input
                  type="text"
                  value={source.href}
                  onChange={(event) =>
                    handleFuentesChange(index, event, 'href')
                  }
                />
              </Col>
            </Fragment>
          );
        })}
      </Row>
      <Row>
        <Col className="text-end mt-2">
          <Button onClick={agregarNuevaFuente}>Agregar Fuente</Button>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Fuentes;
